/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_OverlineInputs */

const en_signin_overline = /** @type {(inputs: Signin_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work with agents`)
};

const id_signin_overline = /** @type {(inputs: Signin_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kerja bareng agen`)
};

/**
* | output |
* | --- |
* | "Work with agents" |
*
* @param {Signin_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_overline = /** @type {((inputs?: Signin_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_overline(inputs)
	return en_signin_overline(inputs)
});